import dataSender, {postCandidateFile} from './ApiService';
import { getReferrer, getSourceId } from './CacheService';

export default function register(data, isAgency = false) {
	if (!isAgency) {
		if (data.hasOwnProperty('positionId') && data.positionId) {
			let actualDate = new Date();
			updateGateStatistics({
				'customerName': data['customerName'],
				'positionId': data.positionId,
				'type': 'cv sent',
				'date': actualDate.getFullYear() + '-' + (actualDate.getMonth() + 1) + '-' + actualDate.getDate()
			});
		}
		data.sourceId = getSourceId();
		data.referrer = getReferrer();
		data.refId = sessionStorage.getItem(data['customerName']+'-refId');
	}

    return dataSender('/api/v2/candidates', data, 'POST');
}

export async function uploadCandidateFile(data,customerName) {
    return postCandidateFile('/api/v2/candidates/'+ sessionStorage.getItem('userId-'+customerName) +'/files', data,customerName);
}

export async function logout(userId, apiKey) {
    return await dataSender('/api/v2/candidates/logout', {"candidateId": userId, 'apiKey': apiKey}, 'POST');
}

export function uploadFileToMongo(data, customerName, language, agencyHash ='') {
    data['apiKey'] = sessionStorage.getItem('apiKey-' + customerName);
    data['candidateId'] = sessionStorage.getItem('userId-' + customerName);
    return postCandidateFile('/api/v2/upload-file/'+language+'/'+customerName+'/'+agencyHash, data, customerName);

}

export function assignCandidateToPosition(data, apiKey = null){
    let actualDate = new Date();
    updateGateStatistics({
        'customerName': data['customerName'],
        'positionId': data['positionId'],
        'type': 'cv sent',
        'date': actualDate.getFullYear()+'-'+(actualDate.getMonth()+1)+'-'+actualDate.getDate()
    });

    data['apiKey'] = apiKey || sessionStorage.getItem('apiKey-' + data['customerName']);
	data.sourceId = getSourceId();
	data.referrer = getReferrer();
	data.refId = sessionStorage.getItem(data['customerName']+'-refId');
	return dataSender('/api/v2/candidates/recru-process', data, 'POST');
}

export function updateGateStatistics(data) {
	data.sourceId = getSourceId();
	data.referrer = getReferrer();
	data.refId = sessionStorage.getItem(data['customerName']+'-refId');
	return dataSender('/api/v2/gatestatistics/update', data, 'POST');
}

export async function checkCandidateRecruProcessExists(firstName, lastName, email, positionId) {
    return dataSender('/api/v2/candidates/recruProcessExists',
        {
                firstName: firstName,
                lastName: lastName,
                email:email,
                positionId: positionId
        },
        'POST').then(response => response.json());
}

export async function sendMailNotification(language, customerName, candidateId, candidateEmail, jobApplicationId, positionId) {
    positionId = positionId === null ? '' : positionId;
    return await dataSender(`/send-email/${customerName}/${candidateId}/${candidateEmail}/${jobApplicationId}${positionId ? '/' + positionId : ''}?lang=${language}`, [], 'POST');
}
